import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, getUser } from '../services/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const user = getUser();
  const roles: string[] = user?.roles || [];
  const isContentEditor = roles.includes('content_editor') && !user?.is_superuser;

  if (isContentEditor) {
    // Allowed prefixes for content editors
    const allowedPrefixes = [
      '/cms',
      '/menu-management',
      '/media',
      '/delphi',
      '/content',
      '/content-dashboard',
      '/matches',          // allow match view/editor
      '/series',           // allow series view
      '/football/matches',
      '/basketball/matches',
      '/football/leagues',
      '/basketball/leagues',
    ];
    const isAllowed = allowedPrefixes.some((prefix) => location.pathname.startsWith(prefix)) || location.pathname === '/';
    if (location.pathname === '/') {
      return <Navigate to="/content-dashboard" replace />;
    }
    if (!isAllowed) {
      return <Navigate to="/content-dashboard" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute; 